import moment from "moment";
import { AcGetAccessToken, AcIsSet } from "ui-kit";

import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import { AppDispatch, RootState } from "../store";

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useIsAuthorized = () => {
  const {access_token = AcGetAccessToken(), expires_at} = useAppSelector(state => state.auth);
  let authorized = false;

  const now = moment();
  let expired = true;
  let expires_in = '';

  if (AcIsSet(expires_at)) {
    expired = expires_at && moment(expires_at, 'X').isBefore(now);
    expires_in = expires_at && moment(expires_at, 'X').fromNow();
  }

  authorized = AcIsSet(access_token) && !expired;

  console.log('Authorized: ', authorized);
  console.groupEnd();

  return authorized;

}
